// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle/squadbusters/" + chunkId + "." + {"322":"78074fa1f074a83b2ccd","416":"d3223f810e324444a1cf","539":"b0f2a8f70874945a42b3","582":"6b860b26541ad7834cce","789":"352044ad462ca52fd08d","869":"1a0c5c84b9ed095f01cb","874":"df4705702a2795674988","964":"dee41492d3662426fef4"}[chunkId] + ".min.js";
};